export default "__VITE_ASSET__CyVsE7Nn__"